/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ICatalogInfoViewProps } from './catalog-info';

export default (props: ICatalogInfoViewProps) => {
    const { className, catalogName, catalogDescription } = props;
    const { showCatalogName, showCatalogDescription } = props.config;

    return (
        <div className={className}>
            {showCatalogName && catalogName}
            {showCatalogDescription && catalogDescription}
        </div>
    );
};
